import styled, { css } from 'styled-components';
import { getSpacingToken } from '@optimus-web/common';
import { Icon, IconName, IconProps } from '@optimus-web/core';
import { WithBreakpointRange, isMobileOrTablet } from '@mews-commander/ui';

export const MoreButtonWrapper = styled.div`
    padding: ${getSpacingToken('100')}px ${getSpacingToken('200')}px;
`;

interface SearchInputIconProps extends IconProps {
    onClick?: () => void;
}

const SearchInputIcon = styled<React.ComponentType<SearchInputIconProps>>(Icon)`
    align-self: center;
    cursor: pointer;
    color: inherit;
`;

export const SearchIcon = styled(SearchInputIcon).attrs({ value: IconName.Search })``;
export const CloseIcon = styled(SearchInputIcon).attrs({ value: IconName.CrossClose })``;

export const PreviousMatchIcon = styled(SearchInputIcon).attrs({ value: IconName.ArrowUp })``;
export const NextMatchIcon = styled(SearchInputIcon).attrs({ value: IconName.ArrowDown })``;

export const NavbarSearchElement = styled.div<WithBreakpointRange>`
    width: 70%;
    ${({ breakpointRange }) =>
        isMobileOrTablet(breakpointRange) &&
        css`
            margin: ${getSpacingToken('200')}px auto;
            width: 100%;
        `}
`;

export const ResultDrawerContainer = styled.div`
    position: relative;
`;
